import React, { useRef, createRef, useEffect, Fragment, useState, useContext } from "react";
import useSWR from "swr";
import scrollToComponent from "react-scroll-to-component-ssr";
import { useHistory } from "react-router";
import { fetcher } from "../../utils/request";
import Footer from "../layout/Footer";
import LogService from "../../utils/logs";
import constants from "../../config/constants";
import { trackPageView } from "../../utils/adobeAnalytics";
import Select from 'react-select'
import AppContext from "../AppContext";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
let subStatus=""
const GlossaryPage = ({ isAuthenticated, userPermission, hasAccessUntil, hasAccess,isMember, userId }) => {
  const [selectedGlossarySources, setSelectedGlossarySources] = useState([]);

  // Adobe Analytics
  const { isFirstRender, setIsFirstRender } = useContext(AppContext);
  useEffect(() => {
    if (!isFirstRender) {
      trackPageView({ eVar4: "glossary page" });
    } else {
      setIsFirstRender(false);
    }
  }, []);
  useEffect(() => {
 if (hasAccess && hasAccess == true) {
            if (isMember == true) {
                subStatus = "subscribed:pmi_membership"
            }
            else {
                subStatus = "subscribed:stdplus_subscription"
            }
        }
        else {
            subStatus = "Non-subscribed"
        }
    if (isAuthenticated) {
      let loginData = {
        event: 'loggedin',
        eventInfo: 'loggedin',
        user: {
          membershipTier: userPermission?.isMember?.membership,
          membershipStatus: userPermission?.isMember?.isMember == true ? 'active' : 'expired',
          pmiID: userId
        }
      }
      let subscriptionStatus = {
        event: "sd-app-load",
        eventInfo: "sd-app-load",
        sd: {
          renewalDate: hasAccessUntil.split('T')[0],
          subStatus: subStatus,

        }
      }
      pushDatatoAdobeLayer({ loginData, status: isAuthenticated, subscriptionStatus })
    }
  }, []);
  // end Adobe Analytics

  useEffect(() => {
    if (!isAuthenticated) {
      history.push(`/login`);
    } else {
      LogService.logPageVisit({
        contentKey: constants.pageKeys.glossary,
        contentSubType: constants.contentSubTypes.page
      });
    }
  }, []);
  const glossayData = (e) => {
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let filteredArray = e && e.length > 0 ? e.map(item => (item.label)) : []
    let filterNameString = filteredArray.length > 0 ? filteredArray.join(", ") : ""
    let contEventObj = getAdobeAnalyticsEventObject(
      "filter",
      "filter",
    );
    let glossaryTrack = {
      event: "filter",
      eventInfo: "filter",
      filter: {
        filterName: filterNameString,
      }
    }
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'filter',
      "Glossary-page",
      '/glossary'
    );
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      onContClickData: { ...contEventObj, ...glossaryTrack },
      pageData: false,
      adobePushTracking: false,
    });
  }
  const history = useHistory();
  const { data: glossaryData, error: glossaryDataErr, isValidating: glossaryDataLoading, mutate: glossaryDataMutate } = useSWR("/api/glossary/data", fetcher);
  const { data: glossaryDataSources, error: glossaryDataSourcesErr, isValidating: glossaryDataSourcesLoading, mutate: glossaryDataSourcesMutate } = useSWR("/api/glossary/sources", fetcher);
  const refs = useRef({});
  const sections = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // sort glossary data by term
  const sortedGlossaryData = glossaryData?.sort && [...glossaryData].sort((a, b) => {
    const aTerm = a.term.toUpperCase();
    const bTerm = b.term.toUpperCase();
    if (aTerm === bTerm) return 0;
    return aTerm > bTerm ? 1 : -1;
  });;

  // refactor "sortedGlossaryData" into an object
  const glossaryTerms = sections.reduce((accumulator, currentVal) => {

    // filter by source
    const filteredGlossaryTerms = sortedGlossaryData?.filter ? sortedGlossaryData.filter(definition => {
      let isFiltered = (definition) => {
        for (let i = 0; i < selectedGlossarySources?.length; i++) {
          if (selectedGlossarySources[i]?.value === definition.sourceId) return true;
        }
        return false;
      }
      if (definition.letter === currentVal && (!selectedGlossarySources?.length || isFiltered(definition))) { return true; }
    }) : [];

    // populate the section object
    const section = {};
    filteredGlossaryTerms.forEach(definition => {
      if (section[definition.term]) { section[definition.term].push(definition) }
      else { section[definition.term] = [definition] }
    })

    // return glossaryTerms object
    return {
      ...accumulator,
      [currentVal]: section
    }

  }, {});

  // sort sources by name
  const sortedGlossaryDataSources = glossaryDataSources?.sort && [...glossaryDataSources].sort((a, b) => {
    const aSource = a.name.toUpperCase();
    const bSource = b.name.toUpperCase();
    if (aSource === bSource) return 0;
    return aSource > bSource ? 1 : -1;
  });;

  // refactor "sortedGlossaryDataSources" into an object
  const sources = sortedGlossaryDataSources?.reduce((accumulator, currentVal) => {
    return {
      ...accumulator,
      [currentVal.id]: {
        ...currentVal,
        name: currentVal.name.replace('PMBOK', 'PMBOK®') // replace PMBOK with PMBOK®
      }
    }
  }, {});

  // refactor "sortedGlossaryDataSources" into dropdown items
  const glossarySourcesDropdown = sortedGlossaryDataSources ? sortedGlossaryDataSources.map(source => ({ label: `${sources[source.id].name} (${source.count})`, value: source.id })) : []

  let sectionsObj = {}

  // Populate "sectionsObj" with only sections that have content
  for (let letter in glossaryTerms) {
    if (glossaryTerms && glossaryTerms[letter] && Object.values(glossaryTerms[letter]).length) { sectionsObj[letter] = glossaryTerms[letter] }
  }

  // A list of the sections that has content
  const activeSections = sectionsObj ? Object.keys(sectionsObj) : null;

  // Check if section has content
  const isSectionEmpty = section => {
    return glossaryTerms && glossaryTerms[section] && Object.values(glossaryTerms[section]).length;
  };

  // add or remove refs
  if (Object.keys(refs.current).length !== activeSections.length) {
    refs.current = activeSections.reduce(
      (acc, section) => ({
        ...acc,
        [section]: refs.current[section] || createRef()
      }),
      {}
    );
  }

  // Display error message if there is a problem retrieving glossary data
  if (glossaryDataErr) {
    return (
      <div className="flex flex-col">
        <div className="bg-gray">
          <div className="bg-red-100 text-red-500 font-bold border-2 border-red-200 container mx-auto mt-24 p-4">
            <p>There was a problem retreiving the glossary data.</p>
          </div>
        </div>
      </div>
    )
  }

  // Display error message if there is a problem retrieving glossary data sources
  if (glossaryDataSourcesErr) {
    return (
      <div className="flex flex-col">
        <div className="bg-gray">
          <div className="bg-red-100 text-red-500 font-bold border-2 border-red-200 container mx-auto mt-24 p-4">
            <p>There was a problem retreiving the glossary data sources.</p>
          </div>
        </div>
      </div>
    )
  }

  // Display error message if glossary data is empty
  if (!glossaryDataLoading && !glossaryData?.length) {
    return (
      <div className="flex flex-col">
        <div className="bg-gray">
          <div className="bg-red-100 text-red-500 font-bold border-2 border-red-200 container mx-auto mt-24 p-4">
            <p>No definitions were returned.</p>
          </div>
        </div>
      </div>
    )
  }

  // Display error message if glossary data sources is empty
  if (!glossaryDataSourcesLoading && !glossaryDataSources?.length) {
    return (
      <div className="flex flex-col">
        <div className="bg-gray">
          <div className="bg-red-100 text-red-500 font-bold border-2 border-red-200 container mx-auto mt-24 p-4">
            <p>No sources were returned.</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col" adoberegion="Glossary-page">
      <div className="bg-gray">
        <div className="container mx-auto mt-24 p-4">
          <h1
            id="section-top"
            className="font-normal text-black text-3xl lg:text-5xl mt-8 mb-8"
          >
            Standards Glossary Terms
          </h1>
        </div>
      </div>
      <div className="bg-white shadow">
        <div className="flex flex-col md:flex-row items-center container mx-auto py-8 px-4">
          <span className="mb-2 md:mb-0 mr-4">FILTER BY SOURCE:</span>
          <span className="flex-grow md:inline-block align-middle w-full md:w-64">
            <Select
              id="glossarySources"
              value={selectedGlossarySources}
              options={glossarySourcesDropdown}
              isMulti
              onChange={(e) => {
                glossayData(e)
                setSelectedGlossarySources(e)
              }} />
          </span>
        </div>
      </div>
      <div className="bg-gray">
        <div className="container mx-auto p-4">
          {sections && (
            <div className="sections flex flex-wrap justify-start border-grey-lighter border-b-2 mb-6">
              {sections.map(section => {
                return (
                  <div
                    className="flex justify-center align-center text-normal font-bold"
                    key={section}
                  >
                    {isSectionEmpty(section) ? (
                      <Fragment>
                        <span
                          className="cursor-pointer text-purple-600 p-2"
                          onClick={() => {
                            scrollToComponent(refs.current[section].current, {
                              offset: -90,
                              align: "top"
                            });
                          }}
                        >
                          {section}
                        </span>
                        <span className="text-gray-600 py-2">|</span>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <span className="text-gray-600 p-2">{section}</span>
                        <span className="text-gray-600 py-2">|</span>
                      </Fragment>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="flex flex-col md:flex-row items-start container mx-auto p-4">
          <div className="sections md:w-2/3 md:pr-12 border-grey-lighter border-b-2 md:border-b-0 mb-8">
            {activeSections.map(section => {

              const terms = glossaryTerms[section];
              const termList = Object.keys(terms)

              return terms ? (
                <div
                  className="border-grey-lighter border-b-2 mb-4"
                  key={section}
                  id={`section-${section}`}
                  ref={refs.current[section]}
                >
                  <div className="definitions">
                    <div className="relative flex justify-between items-end mb-5">
                      <h1
                        className="font-normal text-purple-600 text-3xl"
                        style={{ lineHeight: 0.8 }}
                      >
                        {section}
                      </h1>
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        <span
                          className="font-bold text-grey-dark mr-1"
                          style={{ fontSize: ".7rem" }}
                        >
                          BACK TO TOP
                        </span>
                        <i
                          className="fas fa-chevron-circle-up text-sm"
                          style={{ color: "#6e8393" }}
                        />
                      </div>
                    </div>

                    {termList.map((term, t_index) => {
                      return (
                        <div key={`${term}-${t_index}`} className="terms mb-16">
                          <p className="font-bold text-black mb-8">{term}</p>
                          {
                            terms[term]?.map((definition, d_index) => {
                              return (
                                <div
                                  key={`definition-${d_index}-`}
                                  className={`ml-8 mb-8`}>
                                  <em className={`inline-block text-gray-500 mb-2`}>{sources && sources[definition.sourceId]?.name}</em>
                                  <p
                                    className="text-black mb-8"
                                    dangerouslySetInnerHTML={{ __html: definition.definition }}
                                  />
                                </div>
                              )

                            })
                          }
                        </div>
                      )

                    })}
                  </div>
                </div>
              ) : null;
            })}

          </div>

          <div className="aside md:w-1/3 md:pl-12 md:border-l-2 md:border-gray-400">
            <h1 className="font-bold text-xl mb-8">About the Glossary</h1>
            <p className="mb-8">The glossary is built from several sources:</p>
            {glossaryDataSources?.map(source => (
              <div key={`source-${source.id}`}>
                <p className="font-bold mb-2">{sources[source.id].name}</p>
                <p className="mb-8">{`${source.description ? source.description : "This source does not have a description."}`}</p>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>


    </div>
  );

};

export default GlossaryPage;
